import { Row, Col, Modal } from 'react-bootstrap';
import Messages from './messages';
import { useRef } from 'react';
import "../../css/chat/chat.css";
import { Tooltip, Button, OverlayTrigger } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useTranslation } from 'react-i18next';
import { faFacebook, faInstagram, faTelegram, faTwitter, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faRainbow, faSms, faEnvelope } from "@fortawesome/free-solid-svg-icons";

function LiveChat(props) {

    const { t } = useTranslation();
    const messagesRefs = useRef([]);

    const getIcon = () => {
        let elem = <FontAwesomeIcon size='2x' icon={duotone("messages")} />;
        let channel = "";

        if (props.chat.type !== null)
            channel = props.chat.type.toLowerCase();

        if (channel === "facebook")
            elem = <FontAwesomeIcon size='2x' icon={faFacebook} />;
        if (channel === "whatsapp")
            elem = <FontAwesomeIcon size='2x' icon={faWhatsapp} />;
        if (channel === "instagram")
            elem = <FontAwesomeIcon size='2x' icon={faInstagram} />;
        if (channel === "twitter")
            elem = <FontAwesomeIcon size='2x' icon={faTwitter} />;
        if (channel === "sms")
            elem = <FontAwesomeIcon size='2x' icon={faSms} />;
        if (channel === "telegram")
            elem = <FontAwesomeIcon size='2x' icon={faTelegram} />;
        if (channel === "rainbow")
            elem = <FontAwesomeIcon size='2x' icon={faRainbow} />;
        if (channel === "mail")
            elem = <FontAwesomeIcon size='2x' icon={faEnvelope} />;

        return <span className="fw-bold text-light text-center" >{elem}</span>;
    }

    return (
        <Modal show={props.show} onHide={props.toggleModal} size="lg">
            <Modal.Header>
                <Modal.Title>
                    {
                        (props.chat) &&
                        <Row>
                            <Col lg={4}>
                                {getIcon()}
                            </Col>
                            <Col lg={8}>
                                <div >{props.chat.group}</div>
                                <div >{props.chat.name}</div>
                            </Col>
                        </Row>
                    }
                </Modal.Title>
                <OverlayTrigger
                    placement="left"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip style={{ position: "fixed" }}>
                        {t("close")}
                    </Tooltip>}>
                    <Button onClick={props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                </OverlayTrigger>
            </Modal.Header>
            <Modal.Body style={{ height: "70vh", overflow: "auto" }}>
                <Row>
                    <Col>
                        {
                            props.chat.type.toLowerCase() !== "mail" &&
                            <Messages chat={props.chat} messagesRefs={messagesRefs} agent={props.agent} />
                        }
                        {
                              props.chat.type.toLowerCase() === "mail" &&
                              <iframe title="Mail" src={props.chat.emailUrl} width={"100%"} height={"720px"}></iframe>
                        }
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
}

export default LiveChat;